import { useState, useRef, useEffect } from 'react'

export const useChartWidth = ({ defaultWidth }) => {
  const [width, setWidth] = useState(defaultWidth)

  const componentRef = useRef(null)

  const rafRef = useRef(null)
  const resizeObserverRef = useRef(null)

  useEffect(() => {
    resizeObserverRef.current?.disconnect()

    // rAF defers the measure out of the observer's frame and round+compare drops sub-pixel
    // deltas, so observing the container that holds the redrawn <svg> can't feed back into itself.
    // eslint-disable-next-line compat/compat
    resizeObserverRef.current ||= new window.ResizeObserver(entries => {
      cancelAnimationFrame(rafRef.current)
      rafRef.current = requestAnimationFrame(() => {
        const rect = entries?.[0]?.target?.getBoundingClientRect()

        if (!rect?.width) return

        const next = Math.round(rect.width)
        setWidth(prev => (prev === next ? prev : next))
      })
    })
    if (componentRef.current) {
      resizeObserverRef.current.observe(componentRef.current)
    }

    return () => {
      cancelAnimationFrame(rafRef.current)
      resizeObserverRef.current?.disconnect()
    }
  }, [componentRef.current])

  return {
    componentRef,
    width
  }
}
